<template>
    <FormSection title="Authorized Contacts" :full-height="false" :application-id="application">
        <template #content>
            <div class="d-flex flex-column px-3 py-2">
                <div class="d-flex justify-content-end" v-if="!isReOrderRequested && !showContactForm">
                    <button class="btn btn-primary mb-2" @click="requestReOrder()" v-if="totalContacts > 1">
                        Reorder Contacts
                    </button>
                    <button
                        class="btn btn-primary ms-2 mb-2"
                        @click="openAddContact()"
                        v-if="totalContacts < contactLimit"
                    >
                        Add Contact
                    </button>
                </div>
                <div class="d-flex justify-content-end" v-if="isReOrderRequested">
                    <button class="btn btn-primary mb-2" @click="confirmReOrder()" v-if="totalContacts > 1">
                        <i class="fa fa-spinner fa-spin" v-if="isSavingReOrder"></i>
                        {{ !isSavingReOrder ? "Save Reorder" : "Saving Reorder" }}
                    </button>
                    <button class="btn btn-outline-primary ms-2 mb-2" @click="cancelReOrder()">Cancel</button>
                </div>
                <div
                    :class="`material-card my-2 animated ${showContactForm ? 'faster fadeInDown' : 'slow fadeOutUp'}`"
                    v-if="showContactForm"
                >
                    <AuthorizedContactsForm
                        :relationships-enum="relationshipsEnum"
                        :contact-roles-enum="contactRolesEnum"
                        :contact="contact"
                        :is-editable="true"
                        :total-contacts="totalContacts"
                        :is-loading="isLoading"
                        ref="addContact"
                    />
                    <footer class="d-flex justify-content-center mt-2" v-if="!isLoading">
                        <button type="button" class="btn btn-primary me-2 mb-2" @click="addContact()">
                            Add Contact
                        </button>
                        <button type="button" class="btn btn-outline-primary mb-2" @click="closeAddContact()">
                            Cancel
                        </button>
                    </footer>
                </div>
                <AuthorizedContactsList
                    ref="contactList"
                    :is-re-order-requested="isReOrderRequested"
                    :total-contacts="totalContacts"
                    :patient-id="patientId"
                    :relationships-enum="relationshipsEnum"
                    :contact-roles-enum="contactRolesEnum"
                    :update-contact="updateAuthorizedContact"
                    :delete-contact="deleteAuthorizedContact"
                    :get-authorized-contacts="getContacts"
                />
            </div>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./AuthorizedContacts.ts"></script>
